import { Mapper } from '@/mapper';
import { Journey } from '@/models/journey';
import { MorticianSettings } from '@/models/mortician-settings';
import { Option } from '@/models/option';
import { OptionGroup } from '@/models/option-group';
import { PathSegment } from '@/models/path-segment';
import { createEmptyStatefulRequest, StatefulRequest } from '@/models/stateful-request';
import actions from '@/store/actions';
import mutations from '@/store/mutations';
import { createStore } from 'vuex';
import axios from 'axios';

let journeys: Journey[];
let options: Option[];
let optionGroups: OptionGroup[];

declare global {
   interface Window {
      // eslint-disable-next-line
      funeralConfigurator: any;
   }
}

const fcbId = +window.funeralConfigurator.fcbId;

export async function fetchJourneys() {
   try {
      let path = '/_contao/funeral-configurator/request/journeys';
      path = fcbId ? path + '?fcbId=' + fcbId : path;
      const journeResponse = await axios.get(path);
      journeys = Mapper.parseJourneyResponse(journeResponse);
   }
   catch (e) {
      console.error(e);
   }
}

export async function fetchOptions() {
   try {
       const fetchOptionsResponse = await axios.get('/_contao/funeral-configurator/request/options');
       options = Mapper.parseOptionResponse(fetchOptionsResponse);
   }
   catch (e) {
       console.error(e);
   }
}

export async function fetchOptionGroups() {
   try {
       const fetchOptionsGroupsResponse = await axios.get('/_contao/funeral-configurator/request/option-groups');
       optionGroups = Mapper.parseOptionGroupResponse(fetchOptionsGroupsResponse);
   }
   catch (e) {
       console.error(e);
   }
}
export interface StoreState {
   calculatedPrice: number;
   calculatedExternalPricePart: number;
   currentPathSegment: PathSegment | null;
   callbackRequest: StatefulRequest;
   flashActive: boolean;
   isMobile: boolean;
   journeys: Array<Journey>;
   morticianSettings: MorticianSettings;
   options: Array<Option>;
   optionGroups: Array<OptionGroup>;
   pathSegments: Array<PathSegment>;
   segmentLog: Array<PathSegment>;
   summaryAvailable: boolean;
   summaryActive: boolean;
   quoteRequest: StatefulRequest;
   rootId: number | null;
}

export const defaultState: StoreState = {
   calculatedPrice: 0.0,
   calculatedExternalPricePart: 0.0,
   currentPathSegment: null,
   callbackRequest: createEmptyStatefulRequest(),
   flashActive: false,
   isMobile: window.funeralConfigurator.isMobile,
   journeys: [],
   morticianSettings: Mapper.parseMorticianSettings(window.funeralConfigurator.encodedSettings),
   options: [],
   optionGroups: [],
   pathSegments: [],
   segmentLog: [],
   summaryAvailable: false,
   summaryActive: false,
   quoteRequest: createEmptyStatefulRequest(),
   rootId: window.funeralConfigurator.rootId ?? null
};

export let startState: StoreState = {} as StoreState;

export function getAppStore() {    
   const state = {...defaultState, journeys, options, optionGroups};
   startState = {...defaultState, journeys, options, optionGroups};
   const mapper = new Mapper(state.journeys, state.options, state.optionGroups);
   state.pathSegments = mapper.buildPathSegmentTree(fcbId);

   return createStore({
      state,
      mutations: mutations,
      actions: actions,
      modules: {}
   });
}
